import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Chip,
  CircularProgress,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import adminService from '../../services/adminService';

const statusColor = {
  pending: 'warning',
  failed: 'error',
  abandoned: 'default',
  captured: 'success',
};

const statusLabel = {
  pending: 'Payment Started',
  failed: 'Payment Failed',
  abandoned: 'Payment Not Completed',
  captured: 'Payment Successful',
};

const formatDate = (value) => value ? new Date(value).toLocaleString() : '-';

const PaymentAttempts = () => {
  const [status, setStatus] = useState('all');
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    adminService.getPaymentAttempts(status === 'all' ? {} : { status })
      .then((response) => {
        if (mounted) setAttempts(response.data.attempts || []);
      })
      .catch(() => {
        if (mounted) setError('Failed to load payment attempts');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false; };
  }, [status]);

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 2 }}>
        <Box>
          <Typography variant="h4">Payment Follow-ups</Typography>
          <Typography color="text.secondary">Contact users whose payment was failed or left incomplete.</Typography>
        </Box>
        <Select size="small" value={status} onChange={(event) => setStatus(event.target.value)}>
          <MenuItem value="all">All attempts</MenuItem>
          <MenuItem value="pending">Payment Started</MenuItem>
          <MenuItem value="failed">Payment Failed</MenuItem>
          <MenuItem value="abandoned">Payment Not Completed</MenuItem>
          <MenuItem value="captured">Payment Successful</MenuItem>
        </Select>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Plan</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Reason</TableCell>
                <TableCell>Last Updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {attempts.map((attempt) => (
                <TableRow key={attempt._id}>
                  <TableCell>
                    <Typography variant="body2">{attempt.user?.name || 'Deleted user'}</Typography>
                    <Typography variant="caption" display="block">{attempt.user?.email || '-'}</Typography>
                    <Typography variant="caption">{attempt.user?.phone || '-'}</Typography>
                  </TableCell>
                  <TableCell>{attempt.plan?.name || '-'}</TableCell>
                  <TableCell>₹{Number(attempt.amount || 0) / 100}</TableCell>
                  <TableCell><Chip size="small" label={statusLabel[attempt.status] || attempt.status} color={statusColor[attempt.status] || 'default'} /></TableCell>
                  <TableCell sx={{ maxWidth: 260 }}>{attempt.failureDescription || attempt.failureReason || '-'}</TableCell>
                  <TableCell>{formatDate(attempt.lastEventAt || attempt.updatedAt)}</TableCell>
                </TableRow>
              ))}
              {attempts.length === 0 && <TableRow><TableCell colSpan={6} align="center">No payment attempts found</TableCell></TableRow>}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default PaymentAttempts;
